// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2WXpa","title":"Info_title__2H_Tc","selects":"Info_selects__2_JD-","requiredAsterisk":"Info_requiredAsterisk__3-8lc"};